var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE1HouseZoneChosen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 33H14v14h14V33zm48 22v4H0V29.11l21-14.83L42 28.8V55h34zM4 55h34V30.91L21 19.25l-17 12V55z",
    fill: "#040404"
  })));
}
export default __webpack_public_path__ + "static/media/E1_House_zone_chosen.7199ace0.svg";
export { SvgE1HouseZoneChosen as ReactComponent };